import React__default from 'react';

var defaultSettings = {
    isCompact: false,
    isEditable: true,
};
var CartSettingsContext = React__default.createContext(defaultSettings);

export { CartSettingsContext };
//# sourceMappingURL=CartSettingsContext.esm.js.map
